// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-system-package-version-summary-step-systemPackageVersionSummaryStep-module__container-PovA0K","fieldswrapper":"src-domain-components-system-package-version-summary-step-systemPackageVersionSummaryStep-module__fieldswrapper-bYkXod"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-system-package-version-summary-step-systemPackageVersionSummaryStep-module__container-PovA0K\",\"fieldswrapper\":\"src-domain-components-system-package-version-summary-step-systemPackageVersionSummaryStep-module__fieldswrapper-bYkXod\"}";
        // 1793705033091
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  